module.exports = __webpack_public_path__ + "img/btn_menu_bs_c.bb523b1d.png";